<div class="row mx-3 border border-gray-300 p-2 m-2 yusr-header align-items-center">
    <!-- الجانب الأول: عربي عند العربية، إنجليزي عند الإنجليزية -->
    <div class="col-5 text-center" [dir]="currentLang === 'ar' ? 'rtl' : 'ltr'">
        <ng-container *ngIf="currentLang === 'ar'">
            <h6 class="header-title my-2">شركة تبويب الرقمية</h6>
            <p class=" fs-8 m-0 my-2 header-text">هاتف : 920010967</p>
            <p class=" fs-9 m-0 my-2 header-text">إيميل : info&#64;getyusr.com</p>
            <p class=" fs-9 m-0 my-2 header-text">الطائف المملكة العربية السعودية</p>
        </ng-container>
        <ng-container *ngIf="currentLang === 'en'">
            <h6 class="header-title my-2">Tabweeb Digital</h6>
            <p class=" fs-8 m-0 my-2 header-text">Phone: 920010967</p>
            <p class=" fs-9 m-0 my-2 header-text">Email: info&#64;getyusr.com</p>
            <p class=" fs-9 m-0 my-2 header-text">Taif, Kingdom of Saudi Arabia</p>
        </ng-container>
    </div>

    <!-- الشعار في المنتصف -->
    <div class="col-2 my-2 d-flex justify-content-center align-items-center">
        <!-- <img src="./assets/media/logos/tabweebLogo.png" alt="Metronic logo" class="logo"  loading="lazy"/> -->
        <img [src]="logoSrc" alt="Metronic logo" class="logo mx-auto d-block" loading="lazy" />
    </div>

    <!-- الجانب الثاني: إنجليزي عند العربية، عربي عند الإنجليزية -->
    <div class="col-5 text-center" [dir]="currentLang === 'ar' ? 'ltr' : 'rtl'">
        <ng-container *ngIf="currentLang === 'ar'">
            <h6 class="header-title my-2">Tabweeb Digital</h6>
            <p class=" fs-8 m-0 my-2 header-text">Phone: 920010967</p>
            <p class=" fs-9 m-0 my-2 header-text">Email: info&#64;getyusr.com</p>
            <p class=" fs-9 m-0 my-2 header-text">Taif, Kingdom of Saudi Arabia</p>
        </ng-container>
        <ng-container *ngIf="currentLang === 'en'">
            <h6 class="header-title my-2">شركة تبويب الرقمية</h6>
            <p class=" fs-8 m-0 my-2 header-text">هاتف : 920010967</p>
            <p class=" fs-9 m-0 my-2 header-text">إيميل : info&#64;getyusr.com</p>
            <p class=" fs-9 m-0 my-2 header-text">الطائف المملكة العربية السعودية</p>
        </ng-container>
    </div>
</div>